<template>
  <div>
    <div class="ibox" v-if="service.for_products !== 1">
      <div class="service_pricing_title" :style="service_pricing_title_style">
        <hr />
        <div class="row">
          <div
            class="col-xs-6 p-0-18 m-left-20 mobile-p-0-3 servicePricing_title"
          >
            <label><span class="pricing-title"></span></label>
          </div>
          <div class="col-xs-6 text-right" style="margin-left: -23px">
            <!--                <div class="col-sm-6 text-right" style="margin-top: 15px ;margin-left: -23px;margin-bottom: 15px !important;">-->

            <div
              class="inline float-right service_pricing_collapse_dev"
              style="margin-left: 5px"
            >
              <div class="inline">
                <a
                  :aria-controls="''"
                  aria-expanded="true"
                  class="rotate"
                  role="button"
                  @click="changeToggleServicePricing"
                >
                  <i
                    ref="toggleIcon"
                    v-if="service.viewPage"
                    class="fa serviceCollapse fa-chevron-down"
                  ></i>
                  <i
                    ref="toggleIcon"
                    v-else
                    class="fa fa-chevron-down serviceCollapse"
                  ></i>
                </a>
              </div>
            </div>

            <div
              class="inline float-right service_pricing_collapse_dev pointer"
              @click="changeToggleServicePricing"
              v-if="from !== 'inquiry'"
            >
              <sub-total-field
                :sub-total="totalAfterTax"
                :currency="currency"
                :service="service"
              >
              </sub-total-field>

              <input
                :name="
                  service.clone != 0
                    ? `service_time_${service.service_id}_${service.clone}`
                    : `service_time_${service.service_id}`
                "
                :id="`service_time_${service.service_id}`"
                :value="service.estimate_hours"
                type="hidden"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="toggleServicePricing"
        id="servicePricing_content"
        class="ibox-content price-content border-none"
        :style="toggleServicePricingStyles"
      >
        <div class="form-group">
          <div
            class="row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom"
            v-if="service.charge_by === 'unit' || service.charge_by === 'time'"
          >
            <!-- Check if the quantity attribute is not time then view as a normal attribute -->
            <unit-attribute
              v-if="service.charge_by === 'unit'"
              v-model="quantity"
              :unit-attribute="unitAttribute"
              :quantity-attribute="quantityAttribute"
              :unit-label="service.unit_label"
              :service="service"
            ></unit-attribute>
            <!-- Else if the attribute is time make sure to view at as hours and minutes -->
            <charge-by-time-field
              v-else-if="service.charge_by === 'time'"
              v-model="quantity"
              :quantity-attribute="quantityAttribute"
              :unit-attribute="unitAttribute"
              :service="service"
            ></charge-by-time-field>
          </div>
          <div v-if="from !== 'inquiry'">
            <div
              class="row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom"
              v-if="
                service.serviceRates.length && service.charge_by === 'one_off'
              "
            >
              <service-rate
                :service="service"
                :default-price="this.priceAttribute.default_value"
              ></service-rate>
            </div>
            <div
              :class="[
                'row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom',
                service.charge_by !== 'unit'
                  ? ''
                  : 'm-bottom-12 mobile-no-margin-bottom',
                service.charge_by !== 'time'
                  ? ''
                  : 'm-bottom-12 mobile-no-margin-bottom',
              ]"
            >
              <price-attribute
                v-model="price"
                :service="service"
                :quantity="quantity"
                :currency="currency"
                :price-attribute="priceAttribute"
                :unit-attribute="unitAttribute"
                :suggested-price="suggestedPrice"
              >
              </price-attribute>
              <extra-charge-attribute
                v-model="extraCharge"
                :extra-charge-attribute="extraChargeAttribute"
                :service="service"
                :currency="currency"
                :suggested-price="calculatedExtraCharge"
              ></extra-charge-attribute>
            </div>

            <div
              class="row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom"
            >
              <discount-attribute
                v-model="discount"
                :subtotal-before-discount="serviceAmount"
                :service="service"
                :discount-attributes="discountAttributes"
              ></discount-attribute>

              <deposit-field
                :service="service"
                :add-deposit="true"
              ></deposit-field>

            </div>
            <div
              class="row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom"
            >
              <booking-subtotal-field
                :subtotal="subTotalAfterDiscount"
                :currency="currency"
                :servicePricingPage="true"
              >
              </booking-subtotal-field>

              <tax-rate-field
                v-if="service.showTaxRate"
                :service="service"
                v-model="taxRate"
              ></tax-rate-field>
            </div>
            <div
              class="row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom"
            >
              <booking-total-field
                :total="totalAfterTax"
                :currency="currency"
              >
              </booking-total-field>
            </div>

</div>
            <div
              class="row m-right-0 m-left-0 m-bottom-12 mobile-no-margin-bottom"
            >
              <div
                class="ibox"
                style="position: relative; bottom: 0px; top: 15px"
              >
                <div
                  class="ibox-title"
                  style="background: #f5f5f6; border-top: 0px; padding: 0px"
                >
                  <minimum-charge-field
                    :logged-user="loggedUser"
                    :currency="currency"
                    :service="service"
                    v-model="minimumChargeEnabled"
                  >
                  </minimum-charge-field>
                  <!--                                <sub-total-field :sub-total="subTotalAfterDiscount"-->
                  <!--                                                 :currency="currency"-->
                  <!--                                                 :service="service">-->
                  <!--                                </sub-total-field>-->
                  <!--                                <div :class="{'text-xs-left text-right col-sm-6 col-xs-12': !service.viewPage , ' text-xs-left text-right col-sm-6 col-xs-12 ': service.viewPage}" class="">-->
                  <!--                                    <div class="btn-group">-->
                  <!--                                        <span class="float-right">-->
                  <!--                                            <a href="javascript:;" data-toggle="modal" :data-target="`#${modalId}`">-->
                  <!--                                                <svg width="20" style="fill: #2E4051;" height="20" viewBox="0 0 16 16" fill="none"-->
                  <!--                                                     xmlns="http://www.w3.org/2000/svg" class="bi bi-calculator">-->
                  <!--                                                    <path-->
                  <!--                                                        d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"></path>-->
                  <!--                                                    <path-->
                  <!--                                                        d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"></path>-->
                  <!--                                                </svg>-->
                  <!--                                            </a>-->
                  <!--                                        </span>-->
                  <!--                                            <span class="select-services-dropdown-add-label float-right">-->
                  <!--                                            <a href="javascript:;" data-toggle="modal" :data-target="`#${modalId}`"-->
                  <!--                                               style="text-decoration: none;color: #2E4051;">Calculate price</a>-->
                  <!--                                        </span>-->
                  <!--                                    </div>-->
                  <!--                                </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--        <calculate-service-pricing-modal :id="modalId" :service="service" :currency="currency"-->
    <!--                                         :extra-charge="totalExtraCharge" :suggested-price="suggestedPrice"-->
    <!--                                         :minimum-charge="this.minimumChargeEnabled"></calculate-service-pricing-modal>-->
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import BookingVoucherField from "@/modules/Services/components/billing/types/BookingVoucherField.vue";
// import BookingTotalField from "@/modules/Services/components/billing/types/BookingTotalField.vue";
import ServiceRate from "./types/ServiceRate";
import alert from "bootstrap/js/src/alert";
import {getCompanyInformation} from "@/modules/Services/api/billing"

// Reserved Attribute IDs
const QUANTITY = 15;
const PRICE = 16;
const UNIT = 17;
const DISCOUNT = 19;
const TAX_RATE = 61;
const DESCRIPTION = 46;
const EXTRA_CHARGE = 2359;
const SERVICE_DISCOUNT = 2360;
const SERVICE_DISCOUNT_TYPE = 2361;

export default {
  name: "ServicePricing",
  components: { ServiceRate, BookingVoucherField},
  props: {
    // can be booking or inquiry or invoice etc.
    itemType: {
      default() {
        return "booking";
      },
    },
    service: {
      required: true,
      type: Object,
    },
    // booking or inquiry or invoice id
    itemId: {
      default() {
        return null;
      },
    },
    from: String,
    companyId: {
      required: true,
    },
    currency: {
      required: true,
    },
    loggedUser: {
      required: true,
    },
    products: {
      required: true,
    },
  },
  data() {
    return {
      //(this.loggedUser || {}).role_name === "contractor";
      minimumChargeEnabled: this.service.consider_min_price === 1,
      quantity: 0,
      extraCharge: 0,
      discount: 0,
      price: 0,
      calculatedPrice: 0,
      serviceRatePrice: 0,
      serviceRatetime: 0,
      calculatedExtraCharge: 0,
      taxRate: [],
      subtotalWithoutMinimumCharge: 0.0,
      subtotal: 0.0,
      selectedAttributeOptions: [],
      originalPrice: 0,
      calculateServicePricing: false,
      toggleServicePricing: true,
      companyInfo:null,
      discountIntialized: false
    };
  },
  computed: {
    toggleServicePricingStyles() {
      if (!this.toggleServicePricing && this.service.collapsed) {
        return "padding-bottom: 0px;";
      }

      if (this.toggleServicePricing && this.service.collapsed) {
        return "padding-bottom: 0px;";
      }
    },
    service_pricing_title_style() {
      if (this.toggleServicePricing && !this.service.collapsed) {
        return "padding-top: 10px;";
      } else {
        return "padding-top: 0px;";
      }
    },
    modalId() {
      if (parseInt(this.service.clone)) {
        return `recalculate-service-price-modal-popup_${this.service.service_id}_${this.service.clone}`;
      }

      return `recalculate-service-price-modal-popup_${this.service.service_id}`;
    },
    priceEffectiveAttributes() {
       if ( this?.service?.attributes){
        return this.service.attributes.filter(
            (attribute) => attribute.is_price_attribute
        );
      }else {
        return null
      }

    },
    suggestedPrice() {
      return this.parseFloatOrDefault(this.calculatedPrice);
    },
    totalExtraCharge() {
      return this.parseFloatOrDefault(this.extraCharge);
    },
    discountAttributes() {
      return this.service.attributes.filter(
        (attribute) =>
          this.isDiscount(attribute) || this.isDiscountType(attribute)
      );
    },
    priceAttribute() {
      return this.service.attributes.find((attribute) =>
        this.isPrice(attribute)
      );
    },
    extraChargeAttribute() {
      return this.service.attributes.find((attribute) =>
        this.isExtraCharge(attribute)
      );
    },
    quantityAttribute() {
      return this.service.attributes.find((attribute) =>
        this.isQuantity(attribute)
      );
    },
    unitAttribute() {
      return (
        this.service.attributes.find((attribute) => this.isUnit(attribute)) ??
        {}
      );
    },
    serviceAmount() {
      return this.quantity * this.price + this.extraCharge;
      // return (this.quantity * (this.price + this.additionalCostByPriceEffectiveAttributes)) + ( this.extraCharge + this.additionalCostByExtraChargeEffectiveAttributes)
      // return (1 * (0 + 6)) + 0
    },
    subTotalAfterDiscount() {
      let price = this.serviceAmount - this.discount;
      if (this.productAmount) {
        return price + this.productAmount;
      }
      if (!this.minimumChargeEnabled) {
        return price;
      }

      return Math.max(price, +this.service.min_price - this.discount);
    },
    total() {
      return this.subTotalAfterDiscount;
    },

    finalTaxRate() {
      if (this.service.for_products !== 1) {
        return [
          {
            value: this.taxRate.tax_rate_value
              ? this.approximateNumber( this.total * (+this.taxRate.tax_rate_value / 100) )
              : 0,
            valueWithMinimumCharge: Math.max(
              this.taxRate.tax_rate_value
                ? this.approximateNumber( this.service.min_price * (+this.taxRate.tax_rate_value / 100) )
                : 0,
              this.taxRate.tax_rate_value
                ? this.approximateNumber( this.total * (+this.taxRate.tax_rate_value / 100) )
                : 0
            ),

            ...this.taxRate,
          },
        ];
      }
      let taxRate = [];
      for (let product of this.products) {
        if (product.taxRate) {
          taxRate.push({
            value: product.taxRate.tax_rate_value
              ? product.subTotal * (+product.taxRate.tax_rate_value / 100)
              : 0,
            valueWithMinimumCharge: product.taxRate.tax_rate_value
              ? this.service.min_price * (+product.taxRate.tax_rate_value / 100)
              : 0,
            ...product.taxRate,
          });
        }
      }

      return taxRate;
    },

    totalAfterTax() {
      // this.setCompanyInformation()
      let total = 0;
      if(this.companyInfo != null && this.taxRate && !this.companyInfo.include_tax){
        total = this.subTotalAfterDiscount + ((this.taxRate.tax_rate_value * this.subTotalAfterDiscount)/100)
      }else{
        total = this.subTotalAfterDiscount;
      }
      return this.approximateNumber( total );
    },

    productAmount() {
      let total = 0;
      for (let product of this.products) {
        if (product.subTotal) {
          total += +product.subTotal;
        }
      }

      return total;
    },

    pricing() {
      return {
        discount: this.discount,
        subTotalAfterDiscount: this.subTotalAfterDiscount,
        productAmount: this.productAmount,
        serviceAmount: this.serviceAmount,
        subtotal: this.total,
        extraCharge: this.extraCharge,
        price: this.price,
        minimumChargeEnabled: this.minimumChargeEnabled,
        minimumCharge: this.service.min_price,
        quantity: this.quantity,
        taxRate: this.finalTaxRate,
        total: this.totalAfterTax,
      };
    },
  },
  methods: {
    approximateNumber(number) {
      const numberString = number.toString();
      // Check if there's a decimal point
      const decimalIndex = numberString.indexOf('.');
      if (decimalIndex === -1) {
        return number; // No decimal part, return the number as is
      }

      // Extract the decimal part
      const decimalPart = numberString.slice(decimalIndex + 1);

      // Check if the decimal has at least three digits and the third digit is greater than zero
      if (decimalPart.length >= 3 && parseInt(decimalPart[2]) > 0) {
        return parseFloat((number + 0.001).toFixed(2)); // Add 0.001 and round to 3 decimal places
      }

      return number; // No adjustment needed
    },
    setCompanyInformation() {
      getCompanyInformation()
        .then((response) => this.companyInfo = response.data)
    },
    changeToggleServicePricing() {
      this.toggleServicePricing = !this.toggleServicePricing;
      $(this.$refs.toggleIcon).toggleClass("rotate-180");
    },
    updatePriceAndExtraChargeAndTime() {
      if (this?.priceEffectiveAttributes?.length) {
        this.calculatedExtraCharge = 0;
        let totalAdditionalTimeResult = this.service.default_estimate_hours;
        if (this.service.preparation_time_required) {
          totalAdditionalTimeResult += this.service.preparation_time_required;
        }
        if (
          this.serviceRatePrice &&
          !this.service.hasOwnProperty("location_changed")
        ) {
          this.calculatedPrice = this.parseFloatOrDefault(
            this.serviceRatePrice
          );
        } else {
          this.calculatedPrice = this.parseFloatOrDefault(
            this.priceAttribute.default_value
          );
        }
        if (this.serviceRatetime && this.service.charge_by != "one_off") {
          totalAdditionalTimeResult += this.parseFloatOrDefault(
            this.serviceRatetime
          );
        }

        for (let attribute_selected of this.priceEffectiveAttributes) {
          if (attribute_selected.attribute_values) {
            if (Array.isArray(attribute_selected.selected)) {
              if (attribute_selected.selected.length) {
                for (let attribute_selected_value of attribute_selected.selected) {
                  if (
                    this.service.charge_by != "time" &&
                    attribute_selected_value.cost_type !== "one_off" &&
                    typeof this.service.pricing !== "undefined" &&
                    this.service.pricing.quantity
                  ) {
                    totalAdditionalTimeResult +=
                      attribute_selected_value.additional_time *
                      this.service.pricing.quantity;
                  } else {
                    totalAdditionalTimeResult +=
                      attribute_selected_value.additional_time;
                  }
                  if (attribute_selected_value.cost_type === "one_off") {
                    this.calculatedExtraCharge +=
                      attribute_selected_value.unit_price;
                    //add cost to extra charge value
                  } else if (
                    attribute_selected_value.cost_type === "per_unit"
                  ) {
                    this.calculatedPrice += attribute_selected_value.unit_price;
                    //add cost to price  value
                  } else if (attribute_selected_value.cost_type === "percent") {
                    this.calculatedPrice +=
                      (attribute_selected_value.unit_price / 100) *
                      this.calculatedPrice;
                  }
                }
              }
            } else {
              if (attribute_selected.selected) {
                if (
                  this.service.charge_by != "time" &&
                  attribute_selected.selected.cost_type !== "one_off" &&
                  typeof this.service.pricing !== "undefined" &&
                  this.service.pricing.quantity
                ) {
                  totalAdditionalTimeResult +=
                    attribute_selected.selected.additional_time *
                    this.service.pricing.quantity;
                } else {
                  totalAdditionalTimeResult +=
                    attribute_selected.selected.additional_time;
                }

                if (attribute_selected.selected.cost_type === "one_off") {
                  this.calculatedExtraCharge += this.parseFloatOrDefault(
                    attribute_selected.selected.unit_price
                  );
                  //add cost to extra charge value
                } else if (
                  attribute_selected.selected.cost_type === "per_unit"
                ) {
                  this.calculatedPrice += this.parseFloatOrDefault(
                    attribute_selected.selected.unit_price
                  );
                  //add cost to price  value
                } else if (
                  attribute_selected.selected.cost_type === "percent"
                ) {
                  this.calculatedPrice +=
                    (this.parseFloatOrDefault(
                      attribute_selected.selected.unit_price
                    ) /
                      100) *
                    this.calculatedPrice;
                }
              }
            }
          } else {
            let attribute_value = 0;
            // if (attribute_selected.min){
            //     attribute_value = attribute_selected.min
            // }
            if (attribute_selected.value) {
              attribute_value = attribute_selected.value;
            }
            if (attribute_selected.attribute_additional_time) {
              totalAdditionalTimeResult +=
                this.parseFloatOrDefault(
                  attribute_selected.attribute_additional_time
                ) * this.parseFloatOrDefault(attribute_value);
            }
            this.calculatedExtraCharge +=
              this.parseFloatOrDefault(attribute_selected.unit_price) *
              this.parseFloatOrDefault(attribute_value);
          }
        }
        this.price = this.calculatedPrice;
        this.extraCharge = this.calculatedExtraCharge;
        this.$set(this.service, "estimate_hours", totalAdditionalTimeResult);
      }
    },
    parseFloatOrDefault(value, defaultValue = 0) {
      const result = parseFloat(value);
      return isNaN(result) ? defaultValue : result;
    },
    recalculate(flags) {
      EventBus.$emit("onChangingPriceUpdated", {
        service: this.service,
        flags: flags,
      });
    },
    isQuantity(attribute) {
      return attribute.attribute_id === QUANTITY;
    },
    isPrice(attribute) {
      return attribute.attribute_id === PRICE;
    },
    isDiscount(attribute) {
      return attribute.attribute_id === SERVICE_DISCOUNT;
    },
    isDiscountType(attribute) {
      return attribute.attribute_id === SERVICE_DISCOUNT_TYPE;
    },
    isExtraCharge(attribute) {
      return attribute.attribute_id === EXTRA_CHARGE;
    },
    isTaxRate(attribute) {
      return attribute.attribute_id === TAX_RATE;
    },
    isUnit(attribute) {
      return attribute.attribute_id === UNIT;
    },
    addEventListeners() {
      EventBus.$on("applyRecommended", (values) => {
        this.price = this.suggestedPrice;
        this.extraCharge = this.totalExtraCharge;
        if (this.minimumChargeEnabled) {
          EventBus.$emit("onMinimumChargeFlagUpdated", {
            service: this.service,
            value: true,
          });
        }
      });

      EventBus.$on("onUpdateServiceRate", ({ service_rate }) => {
        this.service.service_rate_value = parseFloat(
          service_rate.service_rate_value
        );
        this.service.service_rate_id = service_rate.service_rate_id;
        this.serviceRatePrice = service_rate.cost;
        this.serviceRatetime = service_rate.average_duration;
        // this.price = (parseFloat(this.calculated_price) + parseFloat(this.service.service_rate_value));
        if (
          this.service.service_id === service_rate.service_id &&
          this.service.clone === service_rate.clone &&
          this.calculateServicePricing
        ) {
          this.updatePriceAndExtraChargeAndTime();
        }
        this.price = parseFloat(this.calculatedPrice);
        this.extraCharge = this.totalExtraCharge;
      });

      EventBus.$on(
        "updateServicePrice",
        ({ service, serviceQuantity, actualTime }) => {
          let quantityTime = serviceQuantity;
          if (typeof actualTime !== "undefined") {
            quantityTime = actualTime;
          }
          this.serviceRatePrice = this.priceAttribute.default_value;
          if (service.charge_by == "unit") {
            this.serviceRatetime =
              quantityTime * service.default_estimate_hours;
          } else {
            this.serviceRatetime = quantityTime;
          }
          if (
            (service.charge_by == "unit" || service.charge_by == "time") &&
            service.serviceRates.length
          ) {
            let serviceRatesCount = service.serviceRates.length; //3-4/6-8/10-12
            let i;
            let serivceRatePriceValue = 0; //9
            let serivceRateTimeValue = 0; //9
            for (i = 0; i < serviceRatesCount; i++) {
              if (
                service.serviceRates[i].min_range <= parseFloat(serviceQuantity)
              ) {
                serivceRatePriceValue = service.serviceRates[i].cost;
                if (service.charge_by == "unit") {
                  serivceRateTimeValue =
                    service.serviceRates[i].average_duration;
                }
              }
            }

            this.serviceRatePrice = serivceRatePriceValue;
            if (service.charge_by == "unit") {
              this.serviceRatetime = serivceRateTimeValue * serviceQuantity;
            }
          }
          if (
            service.service_id === this.service.service_id &&
            service.clone === this.service.clone &&
            this.calculateServicePricing
          ) {
            this.updatePriceAndExtraChargeAndTime();
          }
        }
      );
      EventBus.$on("onMinimumChargeFlagUpdated", ({ service, value }) => {
        if (service.service_id === this.service.service_id) {
          this.minimumChargeEnabled = value;
        }
        if (service.service_id === this.service.service_id && value) {
          this.subtotal = Math.max(this.subtotal, this.service.min_price);
          return;
        }
        this.subtotal = this.subtotalWithoutMinimumCharge;
      });
      EventBus.$on("onServiceCustomFieldSelected", (service_id, clone) => {
        if (
          this.service.charge_by === "one_off" &&
          this.service.serviceRates.length === 0
        ) {
          EventBus.$emit("updateServicePrice", {
            service: this.service,
            serviceQuantity: 1,
            // actualTime: this.service.estimate_hours
          });
        }
        if (
          service_id === this.service.service_id &&
          clone === this.service.clone &&
          this.calculateServicePricing
        ) {
          this.updatePriceAndExtraChargeAndTime();
        }
      });

      EventBus.$on(
        "collapseExpandServicePricing",
        (service_id, clone, isCollapsed) => {
          if (
            this.service.service_id == service_id &&
            this.service.clone == clone
          ) {
            if (isCollapsed == this.toggleServicePricing) {
              this.toggleServicePricing = !this.toggleServicePricing;
              $(this.$refs.toggleIcon).toggleClass("rotate-180");
            }
          }
        }
      );
    },
    applyMinimumChargeIfEnabled() {
      if (this.service.charge_by === "one_off") {
        this.quantity = 1;
      }
      if (this.minimumChargeEnabled) {
        this.subtotal = Math.max(this.subtotal, this.service.min_price);
      }
    },
    calculateDiscount(value){
      if (this.service.discount_ranges && this.service.discount_ranges.length > 0) {
        const disc = this.service.discount_ranges
            .sort((a, b) => a.max_size_range - b.max_size_range)
            .reduce((accumulator, discount) => {
              if (value >= discount.min_size_range && value <= discount.max_size_range) {
                accumulator = discount;
              } else if (
                  this.service.discount_ranges.indexOf(discount) === this.service.discount_ranges.length - 1 &&
                  value >= discount.max_size_range && Object.keys(accumulator).length < 1
              ) {
                accumulator = discount;
              }
              return accumulator; // Ensure we return the accumulator
            }, {});
        if (disc && Object.keys(disc).length > 0) {
          EventBus.$emit('discountChanged',disc.max_discount_range,disc.discount_type)
          // this.discount = disc.max_discount_range
        }else{
          this.$nextTick(() => {
            EventBus.$emit('discountChanged',0)
            // this.discount=0
          });

        }
      }
    }
  },
  mounted() {
    this.addEventListeners();
    this.applyMinimumChargeIfEnabled();
    this.setCompanyInformation()

    this.$nextTick(() => {

      this.calculateServicePricing = true;
      if (!this.service?.meta?.booking?.booking_id) {
        this.updatePriceAndExtraChargeAndTime();
      }
      if (this.service.viewPage && this.from !== "inquiry") {
        this.toggleServicePricing = false;
      }
      if(!this.itemId)
        this.calculateDiscount(this.quantity)
    });
  },
  watch: {
    quantity(value,oldValue){
      if(value!=oldValue && (this.discountIntialized||!this.itemId)) {//In case edit not override the discount
        this.calculateDiscount(value)
      }else
        this.discountIntialized = true
    },
    pricing: {
      handler: function (value, oldValue) {
        if (JSON.stringify(value) !== JSON.stringify(oldValue)) {
          EventBus.$emit("serviceChanged", value);
          this.$emit("input", value);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.servicePricing_title {
  /*padding-left: 0px;*/
  /*margin-left: 0px;*/
}
.price-content {
  padding-top: 0px !important;
}
.service_pricing_title {
  background-color: #f5f5f6;
  color: #2e4051 !important;
  /*border-top-left-radius: 8px;*/
  /*padding-top: 10px;*/
  padding-right: 24px;
  padding-bottom: 25px;
  padding-left: 0px;
  border: none !important;
  /*border-top-right-radius: 15px;*/
  height: auto !important;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
}

@media (max-width: 767px) {
  .servicePricing_title {
    margin-left: 5px !important;
  }
}

@media (max-width: 412px) {
  .service_pricing_title {
    padding-right: 0px;
    padding-bottom: 0px;
  }
}

/*@media (max-width: 375px) {*/
/*@media (max-width: 425px) {*/
@media (max-width: 768px) {
  .service_pricing_collapse_dev {
    margin-left: 0px !important;
    margin-top: 5px;
  }

  .text-xs-left {
    text-align: left !important;
    padding-bottom: 15px;
  }
}

#servicePricing_content {
  padding-bottom: 0px;
}
</style>
